import angular from 'angular';
import { includes, snakeCase } from 'lodash';
import moment from 'moment-timezone';

const OFF_MARKET_STATUSES = ['canceled', 'cancelled', 'expired', 'temp_off_market'];

module.exports = angular.module('common.filters.days-on-market', [])
.filter('daysOnMarket', function() {
  return function(listing) {
    if (!listing) return;

    if (listing.close_date) {
      return moment(listing.close_date).diff(moment(listing.list_date), 'days');
    } else if (includes(OFF_MARKET_STATUSES, snakeCase(listing.listing_status))) {
      return moment(listing.status_change_date).diff(moment(listing.list_date), 'days');
    } else {
      return moment().diff(moment(listing.list_date), 'days');
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/days-on-market.js
 **/